module.exports = __webpack_public_path__ + "img/swac.73223e5a.jpg";